import React, { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import AuthorizationClient from '../single-page/api/AuthorizationClient.js'
import LoadingButton from '../components/LoadingButton.js'
import { trackEvent } from '../single-page/utils';

const useStyles = makeStyles((theme) => ({
  page: {
    width: '100%',
    backgroundColor: '#EFEFEF',
    borderRadius: '16px',
    padding: '24px 14px 22px',
    boxSizing: 'border-box',
  },
  title: {
    color: '#2C5E2E',
    fontWeight: 700,
    marginBottom: '6px',
    textAlign: 'center',
    fontSize: '2rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.7rem',
    },
  },
  subtitle: {
    marginTop: 0,
    fontSize: '1.05rem',
    color: '#255B27',
    textAlign: 'center',
    lineHeight: 1.25,
    marginBottom: '18px',
  },
  form: {
    width: '100%',
    borderRadius: '14px',
    border: '1px solid #2A682C',
    padding: '18px 16px 16px',
    backgroundColor: '#337D36',
    boxSizing: 'border-box',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
  },
  submit: {
    margin: '14px 0 8px',
    borderRadius: '8px',
    backgroundColor: '#225424',
    color: '#FFFFFF',
    fontSize: '1.05rem',
    fontWeight: 700,
    minHeight: '52px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#1C441D',
    },
  },
  submitSignUp: {
    margin: '8px 0 0',
    borderRadius: '8px',
    minHeight: '48px',
    textTransform: 'none',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  fieldLabel: {
    color: '#FFFFFF',
    fontSize: '1rem',
    marginBottom: '8px',
    marginTop: '8px',
  },
  input: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D9DDE5 !important',
    },
  },
  helperText: {
    color: '#FFFFFF',
    marginTop: '4px',
    minHeight: '20px',
  },
  errorAlert: {
    marginBottom: '14px',
    borderRadius: '8px',
    fontWeight: 600,
    fontSize: '0.95rem',
  },
  link: {
    color: '#FFFFFF',
    textDecoration: 'none'
  },
  link2: {
    color: '#fff',
    textDecoration: 'none'
  },
  forgotWrapper: {
    marginTop: '14px',
    textAlign: 'center',
  },
  bottomActions: {
    marginTop: '10px',
  }
}));

export default function SignIn() {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState();
  const [passwordError, setPasswordError] = useState();
  const [loading, setLoading] = useState(false);

  function sign_in(e) {
    e.preventDefault();
    if (loading) return;

    document.activeElement.blur();
    
    setLoading(true);
    setEmailError();
    setPasswordError();
    AuthorizationClient.signIn({email: email, password: password})
      .then(function(){
        trackEvent('Login', { email }, { persistOnRedirect: true, dedupe: false });
        window.location.href = '/'
      })
      .catch(function(error){
        if (error.response?.status == 401){
          setEmailError(error.response.data?.error);
        } else {
          setEmailError();
        }
      })
      .then(function() {
        setLoading(false);
      });
  }

  return (
    <div className={classes.paper}>
      <div className={classes.page}>
      <Typography className={classes.title}>
        Faça seu Login
      </Typography>
      <Typography className={classes.subtitle}>
        Acesse com seu e-mail e senha
      </Typography>
      <form className={classes.form} onSubmit={sign_in} noValidate>
        {emailError && (
          <Alert severity="error" className={classes.errorAlert}>
            {emailError}
          </Alert>
        )}
        <div className={classes.fieldLabel}>Seu e-mail:</div>
        <TextField
          className={classes.input}
          variant="outlined"
          required
          fullWidth
          value={email || ''}
          error={!!emailError}
          placeholder="Digite aqui seu e-mail"
          onChange={(e) => setEmail(e.target.value)}
          onBlur={(e) => setEmail(e.target.value)}
          autoComplete="email"
          autoFocus
        />
        <div className={classes.fieldLabel}>Sua senha:</div>
        <TextField
          className={classes.input}
          variant="outlined"
          required
          fullWidth
          value={password}
          error={!!passwordError}
          placeholder="Digite aqui sua senha"
          onChange={(e) => setPassword(e.target.value)}
          onBlur={(e) => setPassword(e.target.value)}
          type="password"
          autoComplete="current-password"
        />

        <LoadingButton
          type="submit"
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Entrar
        </LoadingButton>
        <div className={classes.bottomActions}>
        <LoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.submitSignUp}
        >
          <Link className={classes.link2} to="/public/sign_in_or_up">
            Entrar com CPF
          </Link>
        </LoadingButton>
        <LoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.submitSignUp}
        >
          <Link className={classes.link2} to="/public/sign_in">
            Criar conta
          </Link>
        </LoadingButton>
        </div>
        <div className={classes.forgotWrapper}>
          <Link className={classes.link} to="/public/request_password_reset" variant="body2">
            Esqueceu sua senha?
          </Link>
        </div>
      </form>
      </div>
    </div>
  );
}